import React from 'react';
import { AdvertisingMetric } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdvertisingConstants';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';

import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import { formatMoney } from 'src/utils/stringFormatting';
import PortfolioStore from '../stores';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Radio } from '@mui/material';
import { useStacklineTheme } from '@stackline/ui';
import { useAppSelector } from 'src/utils/Hooks';

const AddClickField = {
  name: AdvertisingMetric.AD_CLICK,
  displayName: 'Ad\nClicks',
  displayInTable: false
};

const AdSpendField = {
  name: AdvertisingMetric.AD_SPEND,
  displayName: 'Ad\nSpend'
};

const AdSalesField = {
  name: AdvertisingMetric.AD_SALES,
  displayName: 'Ad\nSales'
};
const ROASField = {
  name: AdvertisingMetric.ROAS,
  displayName: 'ROAS'
};

const EntitySelectColumn = ({ entity }: { entity: any }) => {
  const theme = useStacklineTheme();
  const { selectedEntityId, setSelectedEntityId } = PortfolioStore((s) => ({
    setSelectedEntityId: s.setSelectedEntityId,
    selectedEntityId: s.selectedEntityId
  }));

  return (
    <Radio
      checked={selectedEntityId === entity.entityId}
      disableRipple
      disableTouchRipple
      onChange={() => {
        setSelectedEntityId(entity.entityId);
      }}
      sx={{
        padding: '0px !important',
        marginRight: '9px',
        svg: {
          height: '15px',
          width: '15px'
        },
        '& .MuiButtonBase-root': {
          padding: '0px !important'
        },
        '&, &.Mui-checked': {
          color: theme.colors.primary
        }
      }}
    />
  );
};

const EntitySelectColumnDefinition = {
  headerName: '',
  valueFormatter: (_, row) => {
    return <EntitySelectColumn entity={row.entity} />;
  }
};

const EntityNameColumnDefinition = {
  headerName: 'Entity',
  valueFormatter: (_, row) => {
    return <Text variant="body2">{row.name}</Text>;
  }
};

const EntityIdColumnDefinition = {
  headerName: 'Entity ID',
  valueFormatter: (_, row) => {
    return <Text variant="body2">{row.entity.entityId}</Text>;
  }
};

const BudgetColumnDefinition = {
  headerName: 'CURRENT BUDGET',
  valueFormatter: (_, row) => {
    return <Text variant="body2">{formatMoney(row.entity?.extendedAttributes.currentMonthBudgetSetting.amount)}</Text>;
  }
};

const EntityEditor = () => {
  const { adEntities } = useAppSelector((state) => state);

  return (
    <MetricListContainer
      iconList={[]}
      skeletonRows={20}
      headColumnDefinition={[
        EntitySelectColumnDefinition,
        EntityNameColumnDefinition,
        EntityIdColumnDefinition,
        BudgetColumnDefinition
      ]}
      entityTableHeaderProps={{
        title: 'Entity Selection'
      }}
      indexName="adCampaignDailyMetrics"
      fields={[AddClickField, AdSpendField, AdSalesField, ROASField]}
      useTableDataProps={{
        buildRequest: (builder: AdvancedSearchRequestBuilder) => {
          return builder.removeConditionTermFilters((builderFilter) => builderFilter.fieldName === 'categoryId');
        },
        groupByFieldName: 'entityId',
        filterResponse: () => true
      }}
      sortFieldName="clicks"
      showGrid={false}
      postProcessData={(data) => {
        return data.map((row) => {
          return {
            ...row,
            entity: {
              ...row.entity,
              ...adEntities.find((entity: any) => entity.settingId === row.entityId)
            }
          };
        });
      }}
    />
  );
};

export default EntityEditor;
